export const accountTypeOptions = [
    { label: 'Savings', value: 'SAVINGS' },
    { label: 'Current', value: 'CURRENT' },
];